<template>
  <vx-card class="mt-base" :title="activityTitle">
    <h4 class="mb-5">Levers</h4>
    <p class="mb-5">Levers are another very important area for Mechanical Engineers.</p>
    <p class="mb-5">
      Levers allow you to take a relatively small amount of effort and use that to perform an action
      that would normally require a much larger amount of effort or force.
    </p>
    <p class="mb-5">You can learn more about the difference types of levers in the video below.</p>
    <responsive-youtube-wrapper :video="videos[1].video" :image="videos[1].image" />

    <h4 class="mb-5">Your Task:</h4>
    <p class="mb-5">
      Now, you know a little about how levers work and the types of levers, it’s time to put that
      knowledge to good use making something that uses them – an articulated grabber!
    </p>

    <p class="mb-5"><strong>You'll need: </strong></p>

    <div class="vx-row mb-5">
      <div class="vx-col lg:w-1/2">
        <h4 class="mb-5">MATERIALS:</h4>
        <ul class="default-list">
          <li>clean and unbent cardboard</li>
          <li>a sharpened pencil</li>
          <li>masking tape</li>
          <li>25mm metal fasteners</li>
          <li>1/8"x3.5" rubber band</li>
          <li>String</li>
          <li>
            craft sticks, foam, paperclips, or other materials for improving the grabber’s grip
          </li>
          <li>assorted objects to pick up</li>
        </ul>

        <h4 class="mb-5 mt-5">TOOLS:</h4>

        <ul class="default-list">
          <li>A ruler</li>
          <li>A pair of scissors</li>
        </ul>
      </div>
      <div class="vx-col lg:w-1/2">
        <img
          :src="require('@/assets/images/experiences/engineering/items_required.jpg')"
          class="img-responsive"
          alt=""
        />
      </div>
    </div>

    <p class="mb-5">
      Once you’ve gathered up all the materials, it’s time to get started making your articulated
      grabber!
    </p>
    <p class="mb-5">
      <strong><u>Step 1:</u></strong> Watch the overview video below. This will help you to get an
      idea of what you need to do to get started.
    </p>
    <responsive-youtube-wrapper :video="videos[2].video" :image="videos[2].image" />

    <p class="mb-5">
      Now download the document below – these are the instructions you need to follow to create your
      articulated grabber.
    </p>
    <a
      :href="'content/engineering/articulated_grabber_instructions.pdf' | blob_url"
      target="_blank"
    >
      <centered-image-wrapper
        alt="Articulated grabber instructions (PDF) (opens in a new tab)"
        :image="
          require('@/assets/images/experiences/engineering/articulated_grabber_instructions_button.png')
        "
        classes="2/3"
      />
    </a>

    <p class="mb-5">
      When you’ve completed your articulated grabber, take a few photos or a video of your creation
      and upload these here. Ideally, try to take a video of your articulated grabber performing
      some function or task – such as picking something up.
    </p>

    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_1']"
      :is-editable="isEditable"
      filetype="media"
      upload-btn-text="Photo/Video 1"
      index="1"
    />
    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_2']"
      :is-editable="isEditable"
      filetype="media"
      upload-btn-text="Photo/Video 2"
      index="2"
    />
    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_3']"
      :is-editable="isEditable"
      filetype="media"
      upload-btn-text="Photo/Video 3"
      index="3"
    />

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      videos: {
        1: {
          image: require('@/assets/images/experiences/engineering/harnessing_water_power.png'),
          video: 'https://www.youtube.com/embed/A0y_2b8SSbs',
        },
        2: {
          image: require('@/assets/images/experiences/engineering/articulated_grapper_instruction_video.jpg'),
          video: 'https://www.youtube.com/embed/aNUkqJ_xOq8',
        },
      },
      uploaded_files: {
        uploaded_file_1: '',
        uploaded_file_2: '',
        uploaded_file_3: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    for (let i = 1; i <= 3; i++) {
      if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
        this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
      }
    }
  },
};
</script>
